import React, { useState } from 'react';
import PropertyPreview from './PropertyPreview';
import CategoryPage from './category-page';
import RealEstateSideBar from './RealEstateSideBar';
import RealEstateSideBarMobile from './RealEstateSideBarMobile';
import RealEstateFeatured from './RealEstateFeatured';
import RealEstateHeader from '../../Home/Components/RealEstate';
import feaImage from '../../../assets/category/followone_cat_feature_realestate.jpg';

function RealEstateCategory() {
  const [categoryList, setCategoryList] = useState([]);

  function onUpdateCategories(c) {
    if (!categoryList.length)
      setCategoryList(c);
  }

  return (
    <>
      <div className="category-search-panel" style={{ backgroundImage: `url(${feaImage})` }}>
        <RealEstateHeader
          category
          section="realestate"
          categoryList={categoryList}
        />
      </div>
      
      <div className="development-message">
        <h4>Real Estate Section Under Development</h4>
        <p>We're building the Real Estate Section — a dedicated space where users will soon be able to list, discover, and search properties directly from the community. Our team is working on the tools and features needed to make browsing and listing real estate simple, safe, and seamless. Stay tuned as we bring this section to life!</p>
      </div>

      <div className="coming-soon-holder">
        <CategoryPage
          section="realestate"
          description="Search for Real Estate Listings"
          ItemPreview={PropertyPreview}
          SideBar={(props) => (<RealEstateSideBar onLoadCategories={onUpdateCategories} {...props} hideToggleButton />)}
          SideBarMobile={(props) => (<RealEstateSideBarMobile onLoadCategories={onUpdateCategories} {...props} />)}
          FeaturedItems={RealEstateFeatured}
        />
        <div className="coming-soon-cover"></div>
      </div>
    </>
  );
}

export default RealEstateCategory;